import { Injectable } from '@angular/core';

/**
 * Full-page navigation, behind a service so callers can be tested.
 * `window.location.assign` cannot be spied on in current browsers (the property
 * is not writable), so code that redirects goes through here instead.
 */
@Injectable({ providedIn: 'root' })
export class BrowserNavigation {
  redirect(url: string): void {
    window.location.assign(url);
  }
}
